/* eslint-disable no-unused-vars */

import { Get, Post, Delete } from "../Request";
export default {
  state: {
    Coupons: [],
  },
  getters: {
    GetCoupon(state) {
      return state.Coupons;
    },
  },
  actions: {
    async GetCoupon({ commit }, payload) {
      return await Get("Coupon/GetCoupons", payload).then((res) => {
        commit("SetCoupons", res.data.Data);
        return res.data;
      });
    },
    async ToggleStatus({ commit }, payload) {
      return await Delete(`Coupon/ChangeStatus/${payload}`).then((res) => {
        res;
      });
    },
    async AddCoupon({ commit }, payload) {
      return await Post("Coupon/AddCoupon", payload).then((res) => {
        return res.data;
      });
    },
    async DeleteCoupon({ commit }, payload) {
      return await Delete(`Coupon/DeleteCoupon/${payload}`).then((res) => {
        res;
      });
    },
    async EditCoupon({ commit }, payload) {
      return await Post("Coupon/EditCoupon", payload).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetCoupons(state, payload) {
      state.Coupons = payload;
    },
  },
};
